"use client";
import { useState } from "react";
import Image from "next/image";

export default function CommunitySection({ communityData }) {
  const { tabs, content } = communityData;
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const items = content[activeTab];

  return (
    <section className="w-full py-16 bg-white">
      <div className="w-[90%] md:w-[80%] mx-auto">
        <p className="text-base uppercase font-medium text-[#002726]">
          DIVE INTO OUR COMMUNITY
        </p>
        <h2 className="mt-2 text-[36px] font-medium text-[#002726]">
          Learn Online, Connect Offline
        </h2>
        <p className="mt-2 text-[#002726] font-normal text-base">
          Engage with other learners, alumni, and mentors and attend community
          sessions to learn from each other in our curated community.
        </p>

        {/* Tabs */}
        <div className="mt-6 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 rounded-lg transition-colors whitespace-nowrap
                ${
                  activeTab === tab
                    ? "bg-[#032f2e] text-white"
                    : "bg-white text-gray-800 border border-gray-300"
                }
              `}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Custom Grid - 3 columns with specific widths and adjusted heights */}
        <div className="mt-8 flex flex-col md:flex-row gap-6">
          {/* First column - 25% width */}
          <div className="md:w-1/4 flex flex-col gap-6">
            <div className="relative rounded-2xl overflow-hidden h-[380px]">
              <Image
                src={items[0].imageUrl}
                alt={items[0].title}
                fill
                className="object-cover"
              />
              <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] px-4 py-2 flex justify-between items-center text-white">
                <span className="font-medium text-sm">{items[0].title}</span>
                <span className="flex items-center text-sm">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                      fill="white"
                    />
                  </svg>

                  {items[0].location}
                </span>
              </div>
            </div>

            {items[3].type === "stats" ? (
              <div className="flex flex-col items-start justify-start bg-[#002726] rounded-2xl p-6 h-[185px]">
                <span className="text-[70px] font-medium text-[#33C375]">
                  {items[3].count}
                </span>
                <span className="mt-2 text-white uppercase text-sm ">
                  {items[3].description}
                </span>
              </div>
            ) : (
              <div className="relative rounded-2xl overflow-hidden h-[185px]">
                <Image
                  src={items[3].imageUrl}
                  alt={items[3].title}
                  fill
                  className="object-cover"
                />
                <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] bg-opacity-50 px-4 py-2 flex justify-between items-center text-white">
                  <span className="font-medium text-sm">{items[3].title}</span>
                  <span className="flex items-center text-sm">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                        fill="white"
                      />
                    </svg>

                    {items[3].location}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Second column - 25% width */}
          <div className="md:w-1/4 flex flex-col gap-6">
            <div className="relative rounded-2xl overflow-hidden h-[185px]">
              <Image
                src={items[1].imageUrl}
                alt={items[1].title}
                fill
                className="object-cover"
              />
              <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] bg-opacity-50 px-4 py-2 flex justify-between items-center text-white">
                <span className="font-medium text-sm">{items[1].title}</span>
                <span className="flex items-center text-sm">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                      fill="white"
                    />
                  </svg>

                  {items[1].location}
                </span>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-[380px]">
              <Image
                src={items[4].imageUrl}
                alt={items[4].title}
                fill
                className="object-cover"
              />
              <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] bg-opacity-50 px-4 py-2 flex justify-between items-center text-white">
                <span className="font-medium text-sm">{items[4].title}</span>
                <span className="flex items-center text-sm">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                      fill="white"
                    />
                  </svg>

                  {items[4].location}
                </span>
              </div>
            </div>
          </div>

          {/* Third column - 50% width */}
          <div className="md:w-1/2 flex flex-col gap-6">
            <div className="relative rounded-2xl overflow-hidden h-[385px]">
              <Image
                src={items[2].imageUrl}
                alt={items[2].title}
                fill
                className="object-cover"
              />
              <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] bg-opacity-50 px-4 py-2 flex justify-between items-center text-white">
                <span className="font-medium text-sm">{items[2].title}</span>
                <span className="flex items-center text-sm">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                      fill="white"
                    />
                  </svg>

                  {items[2].location}
                </span>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden h-[175px]">
              <Image
                src={items[5].imageUrl}
                alt={items[5].title}
                fill
                className="object-cover"
              />
              <div className="absolute bottom-0 w-full bg-[rgba(0,39,38,0.8)] bg-opacity-50 px-4 py-2 flex justify-between items-center text-white">
                <span className="font-medium text-sm">{items[5].title}</span>
                <span className="flex items-center text-sm">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 1.125C8.29293 1.125 9.53291 1.63861 10.4471 2.55285C11.3614 3.46709 11.875 4.70707 11.875 6C11.875 8.06 10.4275 10.305 7.57 12.759C7.41111 12.8955 7.20853 12.9705 6.99906 12.9703C6.7896 12.9701 6.58715 12.8948 6.4285 12.758L6.2395 12.594C3.5085 10.204 2.125 8.014 2.125 6C2.125 4.70707 2.63861 3.46709 3.55285 2.55285C4.46709 1.63861 5.70707 1.125 7 1.125ZM7 4.125C6.50272 4.125 6.02581 4.32254 5.67418 4.67417C5.32254 5.02581 5.125 5.50272 5.125 6C5.125 6.49728 5.32254 6.97419 5.67418 7.32583C6.02581 7.67746 6.50272 7.875 7 7.875C7.49728 7.875 7.9742 7.67746 8.32583 7.32583C8.67746 6.97419 8.875 6.49728 8.875 6C8.875 5.50272 8.67746 5.02581 8.32583 4.67417C7.9742 4.32254 7.49728 4.125 7 4.125Z"
                      fill="white"
                    />
                  </svg>

                  {items[5].location}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
